import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: JSON.parse(localStorage.getItem('user')),
  },
  getters: {
    getStoreName: (state) => {
      return state.user?.storename || '';
    }
  },
  mutations: {
    reloadStoreName (state) {
      state.user = JSON.parse(localStorage.getItem('user'));
    }
  },
  actions: {
  },
  modules: {
  }
})
